import config from 'constants/apiConfig';
import parseErrorMessage from 'utils/parseErrorMessage';
import {
  GET_ROSTER_FOR_INCIDENT_REQUEST,
  GET_ROSTER_FOR_INCIDENT_SUCCESS,
  GET_ROSTER_FOR_INCIDENT_ERROR,
  ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR,
} from 'constants/incident-action-types';
import axios from 'axios';
import { saveAs } from 'file-saver';

import Blob from 'blob';
import { Parser } from '@json2csv/plainjs';
import { toast } from 'react-toastify';
import { noAutoClose } from 'assets/data/config';

function getRosterForIncidentRequest() {
  return {
    type: GET_ROSTER_FOR_INCIDENT_REQUEST,
  };
}

function getRosterForIncidentSuccess(rosterData) {
  return {
    type: GET_ROSTER_FOR_INCIDENT_SUCCESS,
    payload: rosterData,
  };
}

function getRosterForIncidentError(error) {
  // TODO CRITICAL
  const errorMessage =
    'getRosterForIncidentError\n\n' +
    parseErrorMessage(error) +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: GET_ROSTER_FOR_INCIDENT_ERROR,
  };
}

export function getRosterForIncident() {
  return (dispatch, useState) => {
    const {
      app: { currentIncident },
    } = useState();
    const { id: incidentId } = currentIncident || {};
    dispatch(getRosterForIncidentRequest());
    if (incidentId) {
      return axios(config.apiGateway.getRosterForIncident, {
        method: 'POST',
        data: JSON.stringify({
          incident_id: incidentId,
        }),
      })
        .then((response) => {
          const rolesData = response.data || [];
          dispatch(getRosterForIncidentSuccess(rolesData));

          return rolesData;
        })
        .catch((error) => {
          dispatch(getRosterForIncidentError(error));
        });
    } else {
      dispatch(getRosterForIncidentSuccess([]));
    }
  };
}

export const downloadIncidentLogs = () => {
  return (dispatch, getState) => {
    const incidentMembersLogs = [
      ...getState().app.incidentLogs.incidentMembersLogs.map((e) => {
        return {
          'email_address/name': e.email_address,
          hours_worked: e.minutes_worked_in_words,
          incident_seat: e.incident_seat,
          location: '',
          notes: '',
        };
      }),
    ];
    const incidentNonMembersLogs = [
      ...getState().app.incidentLogs.incidentNonMembersLogs.map((e) => {
        return {
          'email_address/name': e.email_address,
          hours_worked: e.minutes_worked_in_words,
          incident_seat: e.incident_seat,
          location: e.location,
          notes: e.notes,
        };
      }),
    ];
    const IncidentLogs = [...incidentMembersLogs, ...incidentNonMembersLogs];
    let downloadDataBlob;
    if (IncidentLogs.length) {
      const fields = Object.keys(IncidentLogs[0]);
      const opts = { fields };
      const parser = new Parser(opts);
      const csv = parser.parse(IncidentLogs);
      downloadDataBlob = new Blob([csv], {
        type: 'application/csv',
      });
      saveAs(
        downloadDataBlob,
        'DICE ' + getState().app.currentIncident.name + ' logs.csv'
      );
    } else {
      toast.error('There are no records in this log.');
    }
  };
};

function incidentUserError(errorApi, error) {
  const errorMessage =
    errorApi +
    '\n\n' +
    parseErrorMessage(error) +
    '\n\n If you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR,
  };
}
